import request from '../../axios/axiosconfig.js'

export function getAllDevice(params) {
  return request({
    url: '/ps/inWarehouse/getAllDevice',
    method: 'get',
    params: params
  })
}

export function getAllWarehouse() {
  return request({
    url: '/ps/inWarehouse/getAllWarehouse',
    method: 'get'
  })
}

export function inWarehouse(data) {
  return request({
    url: '/ps/inWarehouse/inWarehouse',
    method: 'post',
    data: data
  })
}

export function getAllApply() {
  return request({
    url: '/ps/inWarehouse/getAllApproval',
    method: 'get'
  })
}

export function outWarehouse(data) {
  return request({
    url: '/ps/inWarehouse/outWarehouse',
    method: 'post',
    data: data
  })
}
export function getDeviceInfoById(deviceId) {
  return request({
    url: '/ps/inWarehouse/getDeviceInfoById/'+deviceId,
    method: 'get'
  })
}
export function getDeviceOfflineById(page, deviceId) {
  return request({
    url: '/ps/inWarehouse/getDeviceOfflineById/'+deviceId,
    method: 'get',
    params: page
  })
}
export function getDeviceCmdById(page, deviceId) {
  return request({
    url: '/ps/inWarehouse/getDeviceCmdById/'+deviceId,
    method: 'get',
    params: page
  })
}
export function deviceType() {
  return request({
    url: '/ps/common/deviceCategory',
    method: 'get'
  })
}
export function deviceSupplier() {
  return request({
    url: '/ps/common/deviceSupplier',
    method: 'get'
  })
}

export function changeDeviceType(data) {
  return request({
    url: '/ps/inWarehouse/changeDeviceType',
    method: 'post',
    data: data
  })
}

export function excelUpload(file) {
  return request({
    url: '/ps/common/excelUpload',
    method: 'put',
    data: file,
    headers: {"Content-Type":"multipart/form-data;boundary = " + new Date().getTime()}
  })
}

export function getBanksInfo() {
  return request({
    url: '/ps/inWarehouse/getBanksInfo',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/warehousedevice/warehousedevice.js